/**
 * processOperationLog模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const processOperationLog = {
  // 审批Process
  approvalProcess(params) {
    return $http.post(`${global.API_URL}/sme/processOperationLog/approval`,params);
  }
}

export default processOperationLog;



// WEBPACK FOOTER //
// ./src/api/processOperationLog.js